export default {
  get_pnbon: state => {return state.pnbon},
  get_pcpromo: state => {return state.pcpromo},
  get_pcdev: state => {return state.pcdev},
  get_pmtht: state => {return state.pmtht},
  get_pmtttc: state => {return state.pmtttc},
  get_pmttrsp: state => {return state.pmttrsp},
  get_cart: state => {return state.cart},
  get_reload_cart: state => {return state.reload_cart},
  get_delivery_address: state => {return state.delivery_address},
  get_billing_address: state => {return state.billing_address},
  get_payment_method: state => {return state.payment_method},
  get_payment_form: state => {return state.form_cb_ref},
  get_last_selected_addr_l: state => {return state.last_selected_addr_l},
  get_last_selected_addr_f: state => {return state.last_selected_addr_f},
  get_display_billing_address: state => {return state.display_billing_address},
  get_display_delivery_address: state => {return state.display_delivery_address},
  get_payment_ready: state => {return state.payment_ready},
};